// shopping types
export default {
  GET_TIMESLOT: 'GET_TIMESLOT',
  GET_TIMESLOTS: 'GET_TIMESLOTS',
};
